export default __webpack_public_path__ + "static/media/house.484042e9.svg";